import type { DeviceMode, DevicePlatform, DeviceStatus } from '../types/device';

export const DEVICE_STATUS_LABELS: Record<DeviceStatus, string> = {
  available: 'Available',
  rented: 'Rented',
  maintenance: 'Maintenance',
  unfit: 'Unfit',
};

export const DEVICE_MODE_LABELS: Record<DeviceMode, string> = {
  emulator: 'Emulator',
  simulator: 'Simulator',
  real_device: 'Real Device',
};

export const DEVICE_PLATFORM_LABELS: Record<DevicePlatform, string> = {
  android: 'Android',
  ios: 'iOS',
};

export function formatDeviceStatus(status?: string | null): string {
  if (!status) {
    return '—';
  }
  const key = status.toLowerCase() as DeviceStatus;
  return DEVICE_STATUS_LABELS[key] || status;
}

export function formatDeviceMode(mode?: string | null): string {
  if (!mode) {
    return '—';
  }
  const key = mode.toLowerCase() as DeviceMode;
  return DEVICE_MODE_LABELS[key] || mode;
}

export function formatDevicePlatform(platform?: string | null): string {
  if (!platform) {
    return '—';
  }
  const key = platform.toLowerCase() as DevicePlatform;
  return DEVICE_PLATFORM_LABELS[key] || platform;
}

export function formatFormFactor(formFactor?: string | null): string {
  if (!formFactor) {
    return '—';
  }
  return formFactor.charAt(0).toUpperCase() + formFactor.slice(1);
}

export function getDeviceLookupId(device: { device_id?: string; id?: string }): string {
  return device.device_id || device.id || '';
}

export function isRentedStatus(status?: string | null): boolean {
  return status?.toLowerCase() === 'rented';
}

/** Days selectable for rent / extend (0–14). */
export const RENTAL_DAY_OPTIONS = Array.from({ length: 15 }, (_, days) => ({
  value: String(days),
  label: days === 1 ? '1 Day' : `${days} Days`,
}));

/** Hours selectable for rent / extend (0–23). */
export const RENTAL_HOUR_OPTIONS = Array.from({ length: 24 }, (_, hours) => ({
  value: String(hours),
  label: hours === 1 ? '1 Hour' : `${hours} Hours`,
}));

export function formatRentalPeriod(days: number, hours: number): string {
  const parts: string[] = [];
  if (days > 0) {
    parts.push(days === 1 ? '1 Day' : `${days} Days`);
  }
  if (hours > 0) {
    parts.push(hours === 1 ? '1 Hour' : `${hours} Hours`);
  }
  return parts.length > 0 ? parts.join(', ') : '—';
}

export function addRentalDuration(base: Date, days: number, hours: number): Date {
  const next = new Date(base);
  next.setDate(next.getDate() + days);
  next.setHours(next.getHours() + hours);
  return next;
}
